import request from '@/utils/request'; // 假设你已经封装好了 axios 实例
// 封装一个通用的 GET 请求方法
async function getApiData(store, { url, params = {}, mutationType }) {
  const option = {
    url,
    method: 'get',
    params // 如果有查询参数
  };

  try {
    const res = await request(option);

    if (res.data?.code == 200) {
      if (mutationType) {
        store.commit(mutationType, res.data.data);
      }
      return res.data.data;
    } else {
      // console.error(`API Error: ${res}`);
    }
  } catch (error) {
    console.error(`请求失败: ${url}`, error);
  }
}

export default {
  async axiosUnitList(store) {
    return getApiData(store, {
      url: 'ncc/org/tree/full',
      mutationType: 'setUnitList'
    });
  },

  async fetchAnotherList(store) {
    return getApiData(store, {
      url: 'another/api/endpoint',
      mutationType: 'setAnotherList'
    });
  }

  // 可以继续添加其他接口...
};